import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/**
 * Modale affichée quand /api/acheter renvoie subscription_required (après le 1er sept. 2026).
 */
export default function SubscriptionRequiredPurchaseModal({
  open,
  onOpenChange,
  subscribing,
  onSelectPlan,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="subscribe-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display">Accès payant à partir du 1er septembre 2026</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-700">
          Pour continuer à acheter des dossiers, choisissez votre abonnement.
        </p>
        <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
          <Button
            type="button"
            className="btn-primary h-auto min-h-11 whitespace-normal rounded-xl px-3 py-2.5 text-center text-sm font-semibold leading-snug"
            onClick={() => onSelectPlan("monthly")}
            disabled={subscribing}
            data-testid="subscribe-monthly"
          >
            {subscribing ? "Redirection…" : "249€/mois"}
          </Button>
          <Button
            type="button"
            variant="outline"
            className="h-auto min-h-11 whitespace-normal rounded-xl border-slate-200 px-3 py-2.5 text-center text-sm font-semibold leading-snug text-slate-900 hover:bg-slate-50"
            onClick={() => onSelectPlan("yearly")}
            disabled={subscribing}
            data-testid="subscribe-yearly"
          >
            {subscribing ? "Redirection…" : (
              <>
                199€/mois
                <span className="mt-0.5 block text-xs font-medium text-slate-600">facturé à l&apos;année</span>
              </>
            )}
          </Button>
        </div>
        <p className="text-center text-sm italic text-slate-500">
          1 seul dossier signé rembourse votre abonnement annuel.
        </p>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            className="rounded-xl"
            onClick={() => onOpenChange(false)}
            disabled={subscribing}
          >
            Annuler
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
